import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LayoutRoutes } from "./layout.routing";
import { StatesComponent } from "../masterData/states/states.component";
import { CitiesComponent } from "../masterData/cities/cities.component";
import { UsersComponent } from "../userManagement/users/users.component";
import { UsersProfilesComponent } from "../userManagement/users-profiles/users-profiles.component";
import { OutletTypeHierarchyComponent } from "../userManagement/outlet-type-hierarchy/outlet-type-hierarchy.component";
import { GeographicalHierarchyComponent } from "../userManagement/geographical-hierarchy/geographical-hierarchy.component";
import { GeneralReportsComponent } from "../../hubadmin/reports/general-reports/general-reports.component";
// import { CampaignComponent } from "../../hubadmin/Engagement/campaign/campaign/campaign.component";
import { RegionComponent } from "../../hubadmin/masterData/region/region.component";
import { BrandsComponent } from "../../hubadmin/masterData/brands/brands.component";
import { ChanelComponent } from "../../hubadmin/masterData/chanel/chanel.component";
import { LanguagesComponent } from "../../hubadmin/masterData/languages/languages.component";
import { ModulesComponent } from "../../hubadmin/masterData/modules/modules.component";
import { UnitsComponent } from "../../hubadmin/masterData/units/units.component";
import { FrequencyComponent } from "../../hubadmin/masterData/frequency/frequency.component";
import { NgOrganizationChartModule } from "ng-organization-chart/ng-organization-chart.module";
import { AdminDataProvider } from "../shared/providers/master-provider/admin-data.provider";
// import { SharedModule } from 'src/app/shared/shared.module';
import { RouteDataProvider } from "src/app/shared/providers/RouteDataProvider.provider";
// import { EngagementConfigComponent } from "../engagement-config/engagement-config.component";
import { ListOrderComponent } from "../order-management/list-order/list-order.component";
import { DetailsOrderComponent } from "../order-management/details-order/details-order.component";
import { NgWizardModule, NgWizardConfig, THEME } from "ng-wizard";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { FilterComponentComponent } from "../common/filter-component/filter-component.component";
import { MultiselectComponent } from "../common/multiselect/multiselect.component";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { SharedModule } from "src/app/shared/shared.module";
import { CartonsListComponent } from "../carton/cartons-list/cartons-list.component";
// import { EngagementDashboardComponent } from "../engagement-config/engagement-dashboard/engagement-dashboard.component";
import { BrandCategoriesComponent } from "../masterData/brand-categories/brand-categories.component";
import { ProductsComponent } from "../ecommerce/products/products.component";
import { RolesComponent } from "../masterData/roles/roles.component";
import { RewardCategoriesComponent } from "../rewards/reward-categories/reward-categories.component";
import { RewardHistoryComponent } from "../rewards/reward-history/reward-history.component";
import { RewardProductsComponent } from "../rewards/reward-products/reward-products.component";
import { RewardSubCategoriesComponent } from "../rewards/reward-sub-categories/reward-sub-categories.component";
import { RewardTypesComponent } from "../rewards/reward-types/reward-types.component";
import { SchemeConfigurationComponent } from "../schemes/scheme-configuration/scheme-configuration.component";
import { SchemesListComponent } from "../schemes/schemes-list/schemes-list.component";
import { EditUserComponent } from "../userManagement/edit-user/edit-user.component";
import { ProductEditComponent } from "../ecommerce/product-edit/product-edit.component";
import { VisibilityListComponent } from "../visibility/visiblity-audit-configurations/visibility-list/visibility-list.component";
import { CampaignCreationComponent } from "../campaign/campaign-creation/campaign-creation.component";
import { VisibilityConfigListComponent } from "../visibility/visiblity-audit-configurations/visibility-config-list/visibility-config-list.component";
import { EditCategoryComponent } from "../order-management/edit-category/edit-category.component";
import { ListCategoryComponent } from "../order-management/list-category/list-category.component";
import { ListOfferComponent } from "../ecommerce/list-offer/list-offer.component";
import { VisibilityConfigAddComponent } from "../visibility/visiblity-audit-configurations/visibility-config-add/visibility-config-add.component";
import { CartonCodesComponent } from "../../hubadmin/carton/carton-codes/carton-codes.component";
import { ToastComponent } from "../toast/toast.component";
import { ListTargetAchievementsComponent } from "../target-achievements/list-target-achievements/list-target-achievements.component";
import { AddTargetAchievementsComponent } from "../target-achievements/add-target-achievements/add-target-achievements.component";

import { EnrollUserComponent } from "../../hubadmin/userManagement/enroll-user/enroll-user.component";
// import { GeographyComponent } from '../../hubadmin/masterData/geography/geography.component';
// import { ContentAndLearningComponent } from "../content-and-learning/content-and-learning.component";
// import { AddContentAndLearningComponent } from "../content-and-learning/add-content-and-learning/add-content-and-learning.component";
import { GetVisitsComponent } from "../visit-tracker/get-visits/get-visits.component";
import { CreateVisitsComponent } from "../visit-tracker/create-visits/create-visits.component";
import { GetEnrollmentComponent } from "../visit-tracker/get-enrollment/get-enrollment.component";
import { CreateEnrollmentComponent } from "../visit-tracker/create-enrollment/create-enrollment.component";
import { AddCategoryComponent } from "../../hubadmin/order-management/add-category/add-category.component";
import { ViewEnrollmentComponent } from "../visit-tracker/view-enrollment/view-enrollment.component";
import { WhitelistingComponent } from "../masterData/whitelisting/whitelisting.component";
import { ProductAddComponent } from "../../hubadmin/ecommerce/product-add/product-add.component";
import { AddOfferComponent } from "../ecommerce/add-offer/add-offer.component";
import { UpdateOfferComponent } from "../order-management/update-offer/update-offer.component";
import { CreateProductComponent } from "../rewards/reward-products/create-product/create-product.component";
import { EditProductComponent } from "../rewards/reward-products/edit-product/edit-product.component";
import { DashboardComponent } from "../dashboard/dashboard.component";
import { CreateUserComponent } from "../userManagement/create-user/create-user.component";
import { GetBeatsComponent } from "../../hubadmin/visit-tracker/get-beats/get-beats.component";
import { VisibilitySubmissionsComponent } from "../../hubadmin/visibility/visibility-submissions/visibility-submissions.component";
import { DataTableModule } from "angular2-datatable";
import { VisibilityElementAddComponent } from "../../hubadmin/visibility/visibility-element-add/visibility-element-add.component";
import { VisibilityElementEditComponent } from "../../hubadmin/visibility/visibility-element-edit/visibility-element-edit.component";
import { RangeDatePickerComponent } from "src/app/shared/range-date-picker/range-date-picker.component";
import { VisibilityConfigEditComponent } from "../../hubadmin/visibility/visibility-config-edit/visibility-config-edit.component";
import { LayoutComponent } from "./layout.component";
import { NavbarComponent } from "./navbar/navbar.component";

import { MenuComponent } from "../common/menu/menu.component";
import { SidebarDirective } from "../shared/providers/sidebar.directive";
import { RichTextEditorAllModule } from "@syncfusion/ej2-angular-richtexteditor";
import { UserPointsComponent } from "../user-points/user-points.component";
import { ChillerSelectionComponent } from "../visibility/chiller/chiller-selection/chiller-selection.component";
import { ChillerSchemeComponent } from "../visibility/chiller/chiller-scheme/chiller-scheme.component";
import { VisiblityAuditTypesComponent } from "../visibility/visiblity-templates/visiblity-audit-types/visiblity-audit-types.component";
import { AddEditVisiblityTemplateComponent } from "../visibility/visiblity-templates/add-edit-visiblity-template/add-edit-visiblity-template.component";
import { GeoGroupAddEditComponent } from "../userManagement/geo-group/geo-group-add-edit/geo-group-add-edit.component";
import { GeoGroupComponent } from "../userManagement/geo-group/geo-group.component";
import { GeoUserComponent } from "../userManagement/geo-user/geo-user.component";
import { CoolerElementsComponent } from "../visibility/cooler-elements/cooler-elements.component";
import { CoolerAuditTypesComponent } from "../visibility/visiblity-templates/cooler-audit-types/cooler-audit-types.component";
import { AddEditCoolerAuditTypeComponent } from "../visibility/visiblity-templates/add-edit-cooler-audit-type/add-edit-cooler-audit-type.component";
import { ImageurlsComponent } from "../../hubadmin/masterData/imageurls/imageurls.component";
import { CoolerConfigListComponent } from "../visibility/visiblity-audit-configurations/cooler-config-list/cooler-config-list.component";
import { CoolerConfigAddComponent } from "../visibility/visiblity-audit-configurations/cooler-config-add/cooler-config-add.component";
import { AddChillerSchemeComponent } from "../visibility/chiller/add-chiller-scheme/add-chiller-scheme.component";
import { MobileChangeReportComponent } from "../reports/mobile-change-report/mobile-change-report.component";
import { EnrollementDetailedReportComponent } from "../reports/enrollement-detailed-report/enrollement-detailed-report.component";
import { HomeComponent } from "../reports/home/home.component";
import { AccountStatementComponent } from "../reports/account-statement/account-statement.component";
import { OtherReportComponent } from "../reports/other-report/other-report.component";
import { SchemeReportComponent } from "../reports/scheme-report/scheme-report.component";
import { Bud4tradeReportComponent } from "../reports/bud4trade-report/bud4trade-report.component";
import { CompiledStatewiseReportComponent } from "../reports/compiled-statewise-report/compiled-statewise-report.component";
import { DauReportComponent } from "../reports/dau-report/dau-report.component";
import { EndOfReportComponent } from "../reports/end-of-report/end-of-report.component";
import { EngagementReportComponent } from "../reports/engagement-report/engagement-report.component";
import { LeaderReportComponent } from "../reports/leader-report/leader-report.component";
import { MauTimeReportComponent } from "../reports/mau-time-report/mau-time-report.component";
import { ModuleTimeReportComponent } from "../reports/module-time-report/module-time-report.component";
import { MysteryReportComponent } from "../reports/mystery-report/mystery-report.component";
import { RedmeptionReportComponent } from "../reports/redmeption-report/redmeption-report.component";
import { TargetAchivementsReportComponent } from "../reports/target-achivements-report/target-achivements-report.component";
import { UpliftReportComponent } from "../reports/uplift-report/uplift-report.component";
import { LivepointReportComponent } from "../reports/livepoint-report/livepoint-report.component";
import { EngagementStatementReportComponent } from "../reports/engagement-statement-report/engagement-statement-report.component";
import { HubRedemptionReportComponent } from "../reports/hub-redemption-report/hub-redemption-report.component";
import { PointExpiryRulesComponent } from "../point-expiry-rules/point-expiry-rules.component";
import { AddEditPointExpiryRuleComponent } from "../point-expiry-rules/add-edit-point-expiry-rule/add-edit-point-expiry-rule.component";
import { PointAccountStatementComponent } from "../reports/point-account-statement/point-account-statement.component";
import { GapAnalysisComponent } from "../gap-analysis/gap-analysis.component";
import { GapAnalysisNewUserComponent } from "../gap-analysis-new-user/gap-analysis-new-user.component";
import { MenuSpocEmailComponent } from "../menu-spoc-email/menu-spoc-email.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { MysteryshopperTemplatesComponent } from "../mystery-shopper/mysteryshopper-templates/mysteryshopper-templates.component";
import { AssignMysteryshopperComponent } from "../mystery-shopper/assign-mysteryshopper/assign-mysteryshopper.component";
import { CreateMysteryShopperComponent } from "../mystery-shopper/create-mystery-shopper/create-mystery-shopper.component";
import { MysteryshopperQuestionBankComponent } from "../mystery-shopper/mysteryshopper-question-bank/mysteryshopper-question-bank.component";
import { MysteryshopperWhitelistOutletsComponent } from "../mystery-shopper/mysteryshopper-whitelist-outlets/mysteryshopper-whitelist-outlets.component";
import { AddEditComponent } from "../mystery-shopper/mysteryshopper-whitelist-outlets/add-edit/add-edit.component";
import { AddEditTemplatesComponent } from "../mystery-shopper/mysteryshopper-templates/add-edit-templates/add-edit-templates.component";
import { ListCrownTargetComponent } from "../crown-target/list-crown-target/list-crown-target.component";
import { AddCrownTargetComponent } from "../crown-target/add-crown-target/add-crown-target.component";
import { AppTicketingComponent } from "../app-ticketing/app-ticketing.component";
import { EditTicketComponent } from "../app-ticketing/edit-ticket/edit-ticket.component";
import { AppSchedularComponent } from "../app-schedular/app-schedular.component";
import { ImageConfigurationComponent } from "../masterData/image-configuration/image-configuration.component";
import { DataRefreshComponent } from "../data-refresh/data-refresh.component";
import { CoolerRejectionReasonComponent } from "../visibility/chiller/cooler-rejection-reason/cooler-rejection-reason.component";
import { GapAnalysisReportComponent } from "../gap-analysis-report/gap-analysis-report.component";
import { MakerCheackerConfigurationComponent } from "../masterData/maker-cheacker-configuration/maker-cheacker-configuration.component";
import { NgToggleModule } from "ng-toggle-button";
import { AutoMigrateUsersComponent } from "../auto-migrate-users/auto-migrate-users.component";
import { CreateCartonComponent } from "../carton/create-carton/create-carton.component";
import { WhitelistOutletsComponent } from "../carton/whitelist-outlets/whitelist-outlets.component";
import { CartonStepsComponent } from "../carton/carton-steps/carton-steps.component";
import { SpecialOccasionComponent } from "../carton/special-occasion/special-occasion.component";
import { TargetSetupComponent } from "../carton/target-setup/target-setup.component";
import { CartonUploadComponent } from "../carton/carton-upload/carton-upload.component";
import { CartonInsertReportComponent } from "../reports/carton-insert-report/carton-insert-report.component";
import { OutletMasterReportComponent } from "../reports/outlet-master-report/outlet-master-report.component";
import { PointsLedgerReportComponent } from "../reports/points-ledger-report/points-ledger-report.component";
import { OtpSmsConsumptionComponent } from "../reports/otp-sms-consumption/otp-sms-consumption.component";
import { UserLoginHistoryReportComponent } from "../reports/user-login-history-report/user-login-history-report.component";
import { OutletOnboardingComponent } from "../userManagement/outlet-onboarding/outlet-onboarding.component";
import { CrownListComponent } from "../crown-collection/crown-list/crown-list.component";
import { CrownSetupComponent } from "../crown-collection/crown-setup/crown-setup.component";
import { CreateCrownComponent } from "../crown-collection/create-crown/create-crown.component";
import { CrownPointConfigComponent } from "../crown-collection/crown-point-config/crown-point-config.component";
import { CrownUploadExcelComponent } from "../crown-collection/crown-upload-excel/crown-upload-excel.component";
import { CrownTargetComponent } from "../crown-collection/crown-target/crown-target.component";
import { CrownWhitelistComponent } from "../crown-collection/crown-whitelist/crown-whitelist.component";
import { CashbackReportComponent } from "../cashback-report/cashback-report.component";
import { CreateCashbackComponent } from "../cashback-report/create-cashback/create-cashback.component";
import { WhitelistComponent } from "../cashback-report/whitelist/whitelist.component";
import { CashbackStepsComponent } from "../cashback-report/cashback-steps/cashback-steps.component";
import { UpiListComponent } from "../upi-list/upi-list.component";
import { ComMatrixConfigComponent } from "../carton/com-matrix-config/com-matrix-config.component";
import { Type2WhitelistComponent } from "../carton/type2-whitelist/type2-whitelist.component";
import { Type2CreateComponent } from "../carton/type2-create/type2-create.component";
import { RewardBifurcationComponent } from "../carton/reward-bifurcation/reward-bifurcation.component";
import { PointConfigurationComponent } from "../carton/point-configuration/point-configuration.component";
import { QrDownloadComponent } from "../carton/qr-download/qr-download.component";
import { SettingsComponent } from "../masterData/settings/settings.component";
import { FaqsComponent } from "../masterData/faqs/faqs.component";
import { TypeRewardsComponent } from "../masterData/type-rewards/type-rewards.component";
// import { EngagementDashboardComponent } from "../Engagement/engagement-config/engagement-dashboard/engagement-dashboard.component";
// import { EngagementConfigComponent } from "../Engagement/engagement-config/engagement-config.component";
// import { ContentAndLearningComponent } from "../Engagement/content-and-learning/content-and-learning.component";
// import { AddContentAndLearningComponent } from "../Engagement/content-and-learning/add-content-and-learning/add-content-and-learning.component";
import { WhitelistUsersComponent } from "../schemes/whitelist-users/whitelist-users.component";
import { ViewSingleSchemeComponent } from "../schemes/view-single-scheme/view-single-scheme.component";
import { SchemeSetupComponent } from "../schemes/scheme-setup/scheme-setup.component";
import { CreateSchemeComponent } from "../schemes/create-scheme/create-scheme.component";
import { WhitelistSchemeUserComponent } from "../schemes/whitelist-scheme-user/whitelist-scheme-user.component";
import { SchemeExcelUploadComponent } from "../schemes/scheme-excel-upload/scheme-excel-upload.component";
import { QualifierWhitelistingComponent } from "../schemes/qualifier-whitelisting/qualifier-whitelisting.component";
import { BrandHubComponent } from "../brand-hub/brand-hub/brand-hub.component";
import { BrandHubStepsComponent } from "../brand-hub/brand-hub-steps/brand-hub-steps.component";
import { CreateBrandHubComponent } from "../brand-hub/create-brand-hub/create-brand-hub.component";
import { WhitelistBrandHubComponent } from "../brand-hub/whitelist-brand-hub/whitelist-brand-hub.component";
import { RewardCreateComponent } from "../Reward/reward-create/reward-create.component";
import { RewardSetupComponent } from "../Reward/reward-setup/reward-setup.component";
import { RewardWhitlistUsersComponent } from "../Reward/reward-whitlist-users/reward-whitlist-users.component";
import { RewardsComponent } from "../Reward/rewards/rewards.component";
import { BannerComponent } from "../masterData/banner/banner.component";
import { TargetSetComponent } from "../target-set/target-set.component";
import { ReportModuleComponent } from "../report-module/report-module.component";
import { TargetDeleteComponent } from "../deletion/target-delete/target-delete.component";
import { DeleteAchievementComponent } from "../deletion/delete-achievement/delete-achievement.component";
import { PointsAllocationComponent } from "../deletion/points-allocation/points-allocation.component";
import { PointsCalculationComponent } from "../deletion/points-calculation/points-calculation.component";
import { UserProfileComponent } from "../user-profile/user-profile.component";
import { BonusPointsConfigComponent } from "../bonus-points-config/bonus-points-config.component";
import { AddBonusPointsComponent } from "../add-bonus-points/add-bonus-points.component";
import { BonusSchemeMakerchekerComponent } from "../bonus-scheme-makercheker/bonus-scheme-makercheker.component";
import { NotificationComponent } from "../comm-matrix/sms-notification/notification/notification.component";
import { TriggerNotificationComponent } from "../comm-matrix/trigger-notification/trigger-notification.component";
import { NotificarionComponent } from "../comm-matrix/push-notification/notificarion/notificarion.component";
import { ReminderSmsComponent } from "../comm-matrix/sms-notification/reminder-sms/reminder-sms.component";
import { TemplateSmsComponent } from "../comm-matrix/sms-notification/template-sms/template-sms.component";
import { AdHocNotificationsComponent } from "../comm-matrix/push-notification/ad-hoc-notifications/ad-hoc-notifications.component";

/**
 * Engagement API 
 */

import { ContentAndLearingListComponent } from "../engagement/content-and-learning/content-and-learing-list/content-and-learing-list.component";
import { ContentAndLearingSetupComponent } from "../engagement/content-and-learning/content-and-learing-setup/content-and-learing-setup.component";
import { CreateContentAndLearingComponent } from "../engagement/content-and-learning/create-content-and-learing/create-content-and-learing.component";
import { WhitelistContentAndLearingComponent } from "../engagement/content-and-learning/whitelist-content-and-learing/whitelist-content-and-learing.component";
import { CreateImageTaskComponent } from "../engagement/image-task/create-image-task/create-image-task.component";
import { ImageTaskListComponent } from "../engagement/image-task/image-task-list/image-task-list.component";
import { ImageTaskSetupComponent } from "../engagement/image-task/image-task-setup/image-task-setup.component";
import { WhitelistImageTaskComponent } from "../engagement/image-task/whitelist-image-task/whitelist-image-task.component";
import { CreateQuizTaskComponent } from "../engagement/quiz-task/create-quiz-task/create-quiz-task.component";
import { QuizTaskListComponent } from "../engagement/quiz-task/quiz-task-list/quiz-task-list.component";
import { QuizTaskSetupComponent } from "../engagement/quiz-task/quiz-task-setup/quiz-task-setup.component";
import { WhitelistQuizTaskComponent } from "../engagement/quiz-task/whitelist-quiz-task/whitelist-quiz-task.component";
import { ContentAndLearingExcelUploadComponent } from "../engagement/content-and-learning/content-and-learing-excel-upload/content-and-learing-excel-upload.component";
import { QuizTaskExcelUploadComponent } from "../engagement/quiz-task/quiz-task-excel-upload/quiz-task-excel-upload.component";
import { ImageTaskExcelUploadComponent } from "../engagement/image-task/image-task-excel-upload/image-task-excel-upload.component";
import { ImageSubEngagementComponent } from "../engagement/image-task/image-sub-engagement/image-sub-engagement.component";
import { MultilangComponent } from "../multilang/multilang.component";


const ngWizardConfig: NgWizardConfig = {
  theme: THEME.dots,
};
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(LayoutRoutes),
    FormsModule,
    ReactiveFormsModule,
    NgOrganizationChartModule,
    NgbModule,
    NgWizardModule.forRoot(ngWizardConfig),
    NgMultiSelectDropDownModule.forRoot(),
    SharedModule,
    NgxDatatableModule,
    DataTableModule,
    RichTextEditorAllModule,
    NgToggleModule,

  ],
  declarations: [
    SidebarDirective,
    MenuComponent,
    LayoutComponent,
    UsersComponent,
    SidebarComponent,
    NavbarComponent,
    DashboardComponent,
    StatesComponent,
    CitiesComponent,
    UsersComponent,
    CreateUserComponent,
    UsersProfilesComponent,
    OutletTypeHierarchyComponent,
    GeographicalHierarchyComponent,
    GeneralReportsComponent,
    // CampaignComponent,
    RegionComponent,
    BrandsComponent,
    ChanelComponent,
    LanguagesComponent,
    ModulesComponent,
    UnitsComponent,
    FrequencyComponent,
    LanguagesComponent,
    BrandCategoriesComponent,
    ProductsComponent,
    RolesComponent,
    FilterComponentComponent,
    // EngagementConfigComponent,
    ListOrderComponent,
    DetailsOrderComponent,
    MultiselectComponent,
    // EngagementConfigComponent,
    RewardCategoriesComponent,
    RewardSubCategoriesComponent,
    CreateProductComponent,
    EditProductComponent,
    RewardTypesComponent,
    RewardProductsComponent,
    RewardHistoryComponent,
    CartonsListComponent,
    SchemesListComponent,
    SchemeConfigurationComponent,
    EditUserComponent,
    ProductEditComponent,
    VisibilityListComponent,
    CampaignCreationComponent,
    VisibilityConfigListComponent,
    EditCategoryComponent,
    ListCategoryComponent,
    ListOfferComponent,
    VisibilityConfigAddComponent,
    CartonCodesComponent,
    ToastComponent,
    ListTargetAchievementsComponent,
    AddTargetAchievementsComponent,
    // ContentAndLearningComponent,
    // AddContentAndLearningComponent,
    GetVisitsComponent,
    CreateVisitsComponent,
    GetEnrollmentComponent,
    EnrollUserComponent,
    CreateEnrollmentComponent,
    AddCategoryComponent,
    ViewEnrollmentComponent,
    WhitelistingComponent,
    ProductAddComponent,
    AddOfferComponent,
    UpdateOfferComponent,
    GetBeatsComponent,
    VisibilitySubmissionsComponent,
    VisibilityElementAddComponent,
    VisibilityElementEditComponent,
    VisibilityConfigEditComponent,
    RangeDatePickerComponent,
    UserPointsComponent,
    ChillerSelectionComponent,
    ChillerSchemeComponent,
    VisiblityAuditTypesComponent,
    AddEditVisiblityTemplateComponent,
    GeoGroupAddEditComponent,
    GeoGroupComponent,
    GeoUserComponent,
    CoolerElementsComponent,
    CoolerAuditTypesComponent,
    AddEditCoolerAuditTypeComponent,
    ImageurlsComponent,
    CoolerConfigListComponent,
    CoolerConfigAddComponent,
    AddChillerSchemeComponent,
    MobileChangeReportComponent,
    EnrollementDetailedReportComponent,
    HomeComponent,
    AccountStatementComponent,
    SchemeReportComponent,
    OtherReportComponent,
    Bud4tradeReportComponent,
    MysteryReportComponent,
    RedmeptionReportComponent,
    TargetAchivementsReportComponent,
    CompiledStatewiseReportComponent,
    EndOfReportComponent,
    DauReportComponent,
    EngagementReportComponent,
    MauTimeReportComponent,
    ModuleTimeReportComponent,
    UpliftReportComponent,
    LeaderReportComponent,
    OtherReportComponent,
    LivepointReportComponent,
    EngagementStatementReportComponent,
    HubRedemptionReportComponent,
    PointExpiryRulesComponent,
    AddEditPointExpiryRuleComponent,
    PointAccountStatementComponent,
    GapAnalysisComponent,
    GapAnalysisNewUserComponent,
    MenuSpocEmailComponent,
    CreateMysteryShopperComponent,
    MysteryshopperWhitelistOutletsComponent,
    AssignMysteryshopperComponent,
    MysteryshopperTemplatesComponent,
    MysteryshopperQuestionBankComponent,
    AddEditComponent,
    AddEditTemplatesComponent,
    ListCrownTargetComponent,
    AddCrownTargetComponent,
    AppTicketingComponent,
    EditTicketComponent,
    AppSchedularComponent,
    ImageConfigurationComponent,
    DataRefreshComponent,
    CoolerRejectionReasonComponent,
    GapAnalysisReportComponent,
    MakerCheackerConfigurationComponent,
    AutoMigrateUsersComponent,
    CreateCartonComponent,
    WhitelistOutletsComponent,
    CartonStepsComponent,
    PointConfigurationComponent,
    SpecialOccasionComponent,
    TargetSetupComponent,
    CartonUploadComponent,
    QrDownloadComponent,
    CartonInsertReportComponent,
    OutletMasterReportComponent,
    PointsLedgerReportComponent,
    OtpSmsConsumptionComponent,
    UserLoginHistoryReportComponent,
    OutletOnboardingComponent,
    CrownListComponent,
    CrownSetupComponent,
    CreateCrownComponent,
    CrownPointConfigComponent,
    CrownTargetComponent,
    CrownUploadExcelComponent,
    CrownWhitelistComponent,
    CashbackReportComponent,
    CreateCashbackComponent,
    WhitelistComponent,
    CashbackStepsComponent,
    UpiListComponent,
    RewardBifurcationComponent,
    ComMatrixConfigComponent,
    Type2WhitelistComponent,
    CartonStepsComponent,
    Type2WhitelistComponent,
    Type2CreateComponent,
    ComMatrixConfigComponent,
    Type2WhitelistComponent,
    SettingsComponent,
    FaqsComponent,
    TypeRewardsComponent,
    // engagement
    // CampaignComponent,
    // EngagementDashboardComponent,
    // ContentAndLearningComponent,
    WhitelistUsersComponent,
    ViewSingleSchemeComponent,
    SchemeSetupComponent,
    CreateSchemeComponent,
    WhitelistSchemeUserComponent,
    QualifierWhitelistingComponent,
    SchemeExcelUploadComponent,
    BrandHubComponent,
    BrandHubStepsComponent,
    CreateBrandHubComponent,
    WhitelistBrandHubComponent,
    RewardCreateComponent,
    RewardSetupComponent,
    RewardWhitlistUsersComponent,
    RewardsComponent,
    BannerComponent,
    TargetSetComponent,
    ReportModuleComponent,
    TargetDeleteComponent,
    DeleteAchievementComponent,
    PointsAllocationComponent,
    PointsCalculationComponent,
    UserProfileComponent,
    BonusPointsConfigComponent,
    AddBonusPointsComponent,
    BonusSchemeMakerchekerComponent,
    TriggerNotificationComponent,
    NotificationComponent,
    NotificarionComponent,
    ReminderSmsComponent,
    TemplateSmsComponent,
    AdHocNotificationsComponent,

    // Engagement New
    ContentAndLearingListComponent,
    ContentAndLearingSetupComponent,
    CreateContentAndLearingComponent,
    WhitelistContentAndLearingComponent,
    ContentAndLearingExcelUploadComponent,

    CreateImageTaskComponent,
    ImageTaskListComponent,
    ImageTaskSetupComponent,
    WhitelistImageTaskComponent,
    ImageTaskExcelUploadComponent,
    ImageSubEngagementComponent,

    CreateQuizTaskComponent,
    QuizTaskListComponent,
    QuizTaskSetupComponent,
    WhitelistQuizTaskComponent,
    QuizTaskExcelUploadComponent,


    //multilang
    MultilangComponent,
  ],
  providers: [AdminDataProvider, RouteDataProvider],
})
export class LayoutModule { }
